function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useEffect, useLayoutEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import usePromise from 'react-use-promise-alternative';
import Autosuggest from 'react-autosuggest';
import { withModifiers } from '../../decorators';
import { genId } from '../../helpers/generator';
import AutosuggestHighlightMatch from '../../helpers/autosuggest-highlight/match';
import AutosuggestHighlightParse from '../../helpers/autosuggest-highlight/parse';
import '../../helpers/polyfills/closest';
import { useOnClickOutside } from '../../hooks';
import { Input } from '..';
import { ContextNested } from '../../hooks/context-nested';

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

var DropdownEditable = function DropdownEditable(_ref) {
  var active = _ref.active,
      loading = _ref.loading,
      cancelFetch = _ref.cancelFetch,
      proposals = _ref.proposals,
      proposalDefinition = _ref.proposalDefinition,
      onlyRenderSuggestionsOnFocus = _ref.onlyRenderSuggestionsOnFocus,
      alwaysRenderSuggestions = _ref.alwaysRenderSuggestions,
      disableHighLighting = _ref.disableHighLighting,
      placeholder = _ref.placeholder,
      children = _ref.children,
      className = _ref.className,
      keepFocus = _ref.keepFocus,
      hasIconRight = _ref.hasIconRight,
      hasCustomIcon = _ref.hasCustomIcon,
      hasValidationIcon = _ref.hasValidationIcon,
      disabled = _ref.disabled,
      forceControl = _ref.forceControl,
      id = _ref.id,
      initialValue = _ref.initialValue,
      onChange = _ref.onChange,
      _onClick = _ref.onClick,
      onKeyUp = _ref.onKeyUp,
      onFocus = _ref.onFocus,
      onBlur = _ref.onBlur,
      size = _ref.size,
      type = _ref.type,
      initialStatus = _ref.initialStatus,
      initialHelp = _ref.initialHelp,
      status = _ref.status,
      help = _ref.help,
      getSuggestions = _ref.getSuggestions,
      onSuggestionsFetchRequested = _ref.onSuggestionsFetchRequested,
      onSuggestionsClearRequested = _ref.onSuggestionsClearRequested,
      getSuggestionValue = _ref.getSuggestionValue,
      renderSuggestion = _ref.renderSuggestion,
      onSuggestionSelected = _ref.onSuggestionSelected,
      renderSuggestionsContainer = _ref.renderSuggestionsContainer,
      renderInputComponent = _ref.renderInputComponent,
      callback = _ref.callback,
      promisify = _ref.promisify,
      others = _objectWithoutProperties(_ref, ["active", "loading", "cancelFetch", "proposals", "proposalDefinition", "onlyRenderSuggestionsOnFocus", "alwaysRenderSuggestions", "disableHighLighting", "placeholder", "children", "className", "keepFocus", "hasIconRight", "hasCustomIcon", "hasValidationIcon", "disabled", "forceControl", "id", "initialValue", "onChange", "onClick", "onKeyUp", "onFocus", "onBlur", "size", "type", "initialStatus", "initialHelp", "status", "help", "getSuggestions", "onSuggestionsFetchRequested", "onSuggestionsClearRequested", "getSuggestionValue", "renderSuggestion", "onSuggestionSelected", "renderSuggestionsContainer", "renderInputComponent", "callback", "promisify"]);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      _suggestions = _useState2[0],
      setSuggestions = _useState2[1];

  var _useState3 = useState(active),
      _useState4 = _slicedToArray(_useState3, 2),
      _active = _useState4[0],
      setActive = _useState4[1];

  var _useState5 = useState(null),
      _useState6 = _slicedToArray(_useState5, 2),
      _isLoading = _useState6[0],
      setLoading = _useState6[1];

  var _useState7 = useState(initialValue || ''),
      _useState8 = _slicedToArray(_useState7, 2),
      _value = _useState8[0],
      setValue = _useState8[1];

  var _useState9 = useState(null),
      _useState10 = _slicedToArray(_useState9, 2),
      _keyAction = _useState10[0],
      setKeyAction = _useState10[1];

  var _useState11 = useState(false),
      _useState12 = _slicedToArray(_useState11, 2),
      _inputIsFocused = _useState12[0],
      setInputFocus = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      _isToggled = _useState14[0],
      setToggled = _useState14[1];

  var _useState15 = useState(false),
      _useState16 = _slicedToArray(_useState15, 2),
      _hasMenuRendered = _useState16[0],
      setMenuRendered = _useState16[1];

  var _useState17 = useState(null),
      _useState18 = _slicedToArray(_useState17, 2),
      _menuHeight = _useState18[0],
      setMenuHeight = _useState18[1];

  var _useState19 = useState('below'),
      _useState20 = _slicedToArray(_useState19, 2),
      _menuPosition = _useState20[0],
      setMenuPosition = _useState20[1];

  var _useState21 = useState(initialStatus),
      _useState22 = _slicedToArray(_useState21, 2),
      _initialStatus = _useState22[0],
      setInitialStatus = _useState22[1];

  var _useState23 = useState(initialHelp),
      _useState24 = _slicedToArray(_useState23, 2),
      _initialHelp = _useState24[0],
      setInitialHelp = _useState24[1];

  var dropdownRef = useRef(null);
  var triggerRef = useRef(null);
  var menuRef = useRef(null);
  var outsideClick = useOnClickOutside(dropdownRef);
  useEffect(function () {
    if (!forceControl && !outsideClick) {
      setActive(false);
      setToggled(false);
      setMenuRendered(false);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [outsideClick]);

  var activeConditions = function activeConditions() {
    var conditions = (_suggestions || proposals).length >= 1 && !hasSelection();
    return conditions;
  };

  var hasSelection = function hasSelection() {
    var results = _suggestions || proposals;
    var singleProposal = proposalDefinition ? results[0][proposalDefinition.key] : results[0];
    var selection = results && results.length === 1 && _value === singleProposal;
    return selection;
  };

  var dropDownClasses = classNames('dropdown tile', className, _defineProperty({
    'is-active': !disabled && activeConditions() && forceControl ? active : _active
  }, "is-".concat(size), size));

  var toggleDropdownOnClick = function toggleDropdownOnClick(e) {
    if (disabled) return false;
    var toggleState = activeConditions() && _inputIsFocused && !_isToggled;
    setActive(toggleState);
    if (_inputIsFocused) setToggled(!_isToggled);
    if (typeof _onClick === 'function') _onClick(e);
  };

  var selectDropdownItem = function selectDropdownItem(e) {
    var trigger = triggerRef.current;
    var input = trigger.querySelector("#".concat(_inputProps.id));

    if (keepFocus) {
      setInputFocus(true);
      input.focus();
    } else {
      setInputFocus(false);
      input.blur();
    }

    setActive(false);
    if (typeof _onClick === 'function') _onClick(e);
  };

  useEffect(function () {
    if (!disabled && !forceControl) {
      var activeState = activeConditions() && _inputIsFocused && _keyAction !== 'Enter';

      setActive(activeState);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [_keyAction, _suggestions]);

  var isInViewport = function isInViewport(elem) {
    var bounding = elem.getBoundingClientRect();
    return bounding.top >= 0 && bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight);
  };

  useLayoutEffect(function () {
    if (_hasMenuRendered && menuRef.current != null && menuRef.current.clientHeight !== 0) {
      var height = menuRef.current.clientHeight;
      setMenuHeight(height);
      var position = !isInViewport(menuRef.current) ? 'above' : 'below';
      setMenuPosition(position);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [_hasMenuRendered, menuRef.current, _suggestions]);
  usePromise(function () {
    return promisify ? new Promise(function () {
      onSuggestionsFetchRequested(_value);
    }) : null;
  }, []); // Teach Autosuggest how to calculate suggestions for any given input value.

  function _getSuggestions(value) {
    if (proposals && proposals.length) {
      if (!alwaysRenderSuggestions) {
        var escapedValue = escapeRegexCharacters(value.trim());

        if (escapedValue === '') {
          return [];
        }

        var regex = new RegExp("^".concat(escapedValue), 'i');

        if (proposalDefinition) {
          return proposals.filter(function (proposal) {
            return regex.test(proposal[proposalDefinition.key]);
          });
        }

        return proposals.filter(function (proposal) {
          return regex.test(proposal);
        });
      }

      return proposals;
    }
  }

  var _onSuggestionsFetchRequested =
  /*#__PURE__*/
  function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref2) {
      var value, suggestions;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              value = _ref2.value;

              if (!cancelFetch) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return", false);

            case 3:
              if (loading === undefined) setLoading(true);
              suggestions = [];

              if (!(typeof onSuggestionsFetchRequested === 'function')) {
                _context.next = 10;
                break;
              }

              _context.next = 8;
              return onSuggestionsFetchRequested(value);

            case 8:
              suggestions = _context.sent;
              setSuggestions(suggestions);

            case 10:
              if (!alwaysRenderSuggestions) {
                suggestions = _getSuggestions(value);
                setSuggestions(suggestions);
              } else {
                if (proposals && proposals.length) setSuggestions(proposals);
              }

              setMenuRendered(false);
              if (loading === undefined) setLoading(false);

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function _onSuggestionsFetchRequested(_x) {
      return _ref3.apply(this, arguments);
    };
  }(); // Autosuggest will call this function every time you need to clear suggestions.


  var _onSuggestionsClearRequested = function _onSuggestionsClearRequested() {
    setSuggestions([]);
  }; // When suggestialwaysRenderSuggestionson is clicked, Autosuggest needs to populate the input
  // based on the clicked suggestion. Teach Autosuggest how to calculate the
  // input value for every given suggestion.


  var _getSuggestionValue = function _getSuggestionValue(suggestion) {
    return proposalDefinition ? suggestion[proposalDefinition.key] : suggestion;
  }; // Use your imagination to render suggestions.


  var _renderSuggestion = function _renderSuggestion(suggestion, _ref4) {
    var query = _ref4.query;
    var suggestionText = proposalDefinition ? suggestion[proposalDefinition.key] : suggestion;

    if (disableHighLighting || query === '' || typeof query === 'undefined') {
      return React.createElement("div", {
        className: "dropdown-item is-tri",
        onClick: function onClick(e) {
          return selectDropdownItem(e);
        }
      }, React.createElement("span", {
        className: className
      }, suggestionText));
    }

    var matches = AutosuggestHighlightMatch(suggestionText, query);
    var parts = AutosuggestHighlightParse(suggestionText, matches);
    return React.createElement("div", {
      className: "dropdown-item is-tri",
      onClick: function onClick(e) {
        return selectDropdownItem(e);
      }
    }, parts.map(function (part, index) {
      var className = part.highlight ? 'has-text-info' : null;
      return React.createElement("span", {
        className: className,
        key: index
      }, part.text);
    }));
  };

  var _onSuggestionSelected = function _onSuggestionSelected(event, _ref5) {
    var suggestion = _ref5.suggestion,
        suggestionValue = _ref5.suggestionValue,
        suggestionIndex = _ref5.suggestionIndex,
        sectionIndex = _ref5.sectionIndex,
        method = _ref5.method;

    if (typeof onSuggestionSelected === 'function') {
      onSuggestionSelected(event, {
        suggestion: suggestion,
        suggestionValue: suggestionValue,
        suggestionIndex: suggestionIndex,
        sectionIndex: sectionIndex,
        method: method
      });
    }
  };

  var _focusInputOnSuggestionClick = function _focusInputOnSuggestionClick() {
    // Override for Autosuggest bug => Object.onSuggestionClick [as onClick] when onSuggestionClick
    // We use selectDropdownItem to control whether we focus or blur the input by setting props keepFocus
    // Please see documentation https://github.com/moroshko/react-autosuggest#should-render-suggestions-prop
    return null;
  };

  var _renderInputComponent = function _renderInputComponent(inputProps) {
    return React.createElement("div", {
      className: "dropdown-trigger is-tri",
      ref: triggerRef,
      onClick: function onClick(e) {
        return forceControl ? _onClick(e) : toggleDropdownOnClick(e);
      }
    }, React.createElement(Input, _extends({}, inputProps, {
      forceControl: true,
      "is-fullwidth": true,
      hasSearching: (_isLoading || loading) && _inputIsFocused
    })));
  };

  var _renderSuggestionsContainer = function _renderSuggestionsContainer(_ref6) {
    var containerProps = _ref6.containerProps,
        children = _ref6.children;
    if (!children) return null;
    setMenuRendered(true);
    return React.createElement("div", {
      ref: menuRef,
      className: "dropdown-menu is-tri",
      style: _menuPosition === 'above' && _menuHeight ? {
        top: "-".concat(_menuHeight + 4, "px")
      } : null
    }, React.createElement("div", {
      className: "dropdown-content"
    }, React.createElement("div", containerProps, children)));
  };

  var _onChange = function _onChange(event, _ref7) {
    var newValue = _ref7.newValue,
        method = _ref7.method;
    setValue(newValue);
    setKeyAction(method);
    setMenuRendered(false);
    setInitialStatus(null);
    setInitialHelp(null);
    if (typeof callback === 'function') callback(newValue, _suggestions);
    if (typeof onChange === 'function') onChange(event, {
      newValue: newValue,
      method: method
    });
  };

  var _onKeyUp = function _onKeyUp(event) {
    setKeyAction(event.key);
    if (typeof onKeyUp === 'function') onKeyUp(event);
  };

  var _onFocus = function _onFocus(event) {
    if (disabled) return false;
    setInputFocus(true);
    setMenuRendered(false);
    setMenuPosition('below');

    if (alwaysRenderSuggestions && typeof onSuggestionsFetchRequested !== 'function') {
      if (proposals && proposals.length) setSuggestions(proposals);
    }

    if (typeof onFocus === 'function') onFocus(event);
  };

  var _onBlur = function _onBlur(event) {
    setInputFocus(false);
    if (typeof onBlur === 'function') onBlur(event);
  }; // Autosuggest will pass through all these props to the input.


  var _inputProps = {
    id: "dropdown-editable-input-".concat(id),
    status: !_inputIsFocused && _initialStatus || status,
    help: !_inputIsFocused && _initialHelp || help,
    placeholder: placeholder,
    className: className,
    hasIconRight: hasIconRight,
    hasValidationIcon: hasValidationIcon,
    hasCustomIcon: hasCustomIcon,
    disabled: disabled,
    value: initialValue || _value,
    onChange: _onChange,
    onKeyUp: _onKeyUp,
    onBlur: _onBlur,
    onFocus: _onFocus // props pass to original component according to incoming props

  };
  getSuggestions = typeof getSuggestions === 'function' ? getSuggestions : _getSuggestions;
  onSuggestionsClearRequested = typeof onSuggestionsClearRequested === 'function' ? onSuggestionsClearRequested : _onSuggestionsClearRequested;
  getSuggestionValue = typeof getSuggestionValue === 'function' ? getSuggestionValue : _getSuggestionValue;
  renderSuggestion = typeof renderSuggestion === 'function' ? renderSuggestion : _renderSuggestion;
  renderSuggestionsContainer = typeof renderSuggestionsContainer === 'function' ? renderSuggestionsContainer : _renderSuggestionsContainer;
  renderInputComponent = typeof renderInputComponent === 'function' ? renderInputComponent : _renderInputComponent;

  var _contextNested = useContext(ContextNested);

  return React.createElement(ContextNested.Provider, {
    value: {
      isNestedInParent: 'div',
      isNestedInlink: _contextNested.isNestedInlink
    }
  }, React.createElement("div", {
    ref: dropdownRef,
    className: "field"
  }, React.createElement("span", {
    className: classNames('control is-tri', {
      'is-disabled': disabled
    })
  }, React.createElement("span", _extends({
    id: id
  }, {
    className: dropDownClasses
  }, others), React.createElement(Autosuggest, _extends({
    suggestions: _suggestions || proposals,
    getSuggestions: getSuggestions,
    onSuggestionsFetchRequested: _onSuggestionsFetchRequested,
    onSuggestionsClearRequested: onSuggestionsClearRequested,
    getSuggestionValue: getSuggestionValue,
    renderSuggestion: renderSuggestion,
    focusInputOnSuggestionClick: _focusInputOnSuggestionClick,
    onSuggestionSelected: _onSuggestionSelected,
    renderSuggestionsContainer: renderSuggestionsContainer,
    renderInputComponent: renderInputComponent,
    alwaysRenderSuggestions: alwaysRenderSuggestions,
    inputProps: _inputProps
  }, others))))));
};

DropdownEditable.propTypes = {
  id: PropTypes.string,
  initialValue: PropTypes.string,
  children: PropTypes.any,
  className: PropTypes.string,
  keepFocus: PropTypes.bool,
  hasIconRight: PropTypes.bool,
  placeholder: PropTypes.string,
  initialStatus: PropTypes.string,
  initialHelp: PropTypes.text,
  status: PropTypes.string,
  help: PropTypes.text,
  disabled: PropTypes.bool,
  hasValidationIcon: PropTypes.bool,
  hasCustomIcon: PropTypes.element,
  type: PropTypes.text,
  size: PropTypes.number,
  active: PropTypes.bool,
  loading: PropTypes.bool,
  cancelFetch: PropTypes.bool,
  onlyRenderSuggestionsOnFocus: PropTypes.bool,
  alwaysRenderSuggestions: PropTypes.bool,
  disableHighLighting: PropTypes.bool,
  forceControl: PropTypes.bool,
  onClick: PropTypes.func,
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  containerProps: PropTypes.object,
  proposals: PropTypes.array.isRequired,
  proposalDefinition: PropTypes.object,
  getSuggestions: PropTypes.func,
  onSuggestionsFetchRequested: PropTypes.func,
  onSuggestionsClearRequested: PropTypes.func,
  getSuggestionValue: PropTypes.func,
  renderSuggestion: PropTypes.func,
  focusInputOnSuggestionClick: PropTypes.func,
  onSuggestionSelected: PropTypes.func,
  renderSuggestionsContainer: PropTypes.func,
  renderInputComponent: PropTypes.func,
  callback: PropTypes.func,
  promisify: PropTypes.bool
};
DropdownEditable.defaultProps = {
  id: genId(),
  placeholder: "Type 'c'",
  proposalDefinition: {
    key: 'item'
  },
  proposals: [{
    item: 'C',
    group: 1972
  }, {
    item: 'C#',
    group: 2000
  }, {
    item: 'C++',
    group: 1983
  }, {
    item: 'Clojure',
    group: 2007
  }, {
    item: 'Elm',
    group: 2012
  }, {
    item: 'Go',
    group: 2009
  }, {
    item: 'Haskell',
    group: 1990
  }, {
    item: 'Java',
    group: 1995
  }, {
    item: 'Javascript',
    group: 1995
  }, {
    item: 'Perl',
    group: 1987
  }, {
    item: 'PHP',
    group: 1995
  }, {
    item: 'Python',
    group: 1991
  }, {
    item: 'Ruby',
    group: 1995
  }, {
    item: 'Scala',
    group: 2003
  }]
};
export default withModifiers(DropdownEditable);